import { lazy, Suspense, useState } from 'react';
import Share from '@alltrails/shared/icons/Share';
import { COLOR_INTERACTIVE_DEFAULT } from '@alltrails/shared/denali/tokens';
import logTrailDetailsShareButtonTapped from '@alltrails/analytics/events/logTrailDetailsShareButtonTapped';
import useUser from 'hooks/useUser';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import useLanguageCode from 'hooks/useLanguageCode';
import { Trail } from 'types/Trails';
import useToggle from '@alltrails/shared/hooks/useToggle';
import { useIntl } from '@alltrails/shared/react-intl';
import { NoSsr } from '@material-ui/core';
import { renderShareModal } from '../../application/javascripts/react_components/main_action_bar/share_modal';
import ActionBarItem from '../ActionBarItem';

const SignupModal = lazy(() => import('components/SignupModal'));

type SharePopupButtonProps = {
  className?: string;
  shareObject: unknown;
  trail?: Trail;
  onClick?: () => void;
};

function SharePopupButton({ className, shareObject, trail, onClick }: SharePopupButtonProps): JSX.Element {
  const intl = useIntl();
  const [isOpen, toggle] = useToggle();
  const languageCode = useLanguageCode();
  const languageRegionCode = useLanguageRegionCode();
  const user = useUser();
  const [showShareModal, setShowShareModal] = useState(false);

  function hideShareModal() {
    setShowShareModal(false);
  }

  return (
    <>
      <NoSsr>
        <Suspense fallback={null}>
          <SignupModal
            isOpen={isOpen}
            onRequestClose={() => {
              toggle();
            }}
            onSuccess={() => {
              toggle();
              setShowShareModal(true);
            }}
          />
        </Suspense>
      </NoSsr>
      <ActionBarItem
        onClick={() => {
          if (onClick) {
            onClick();
          }

          if (!user) {
            logTrailDetailsShareButtonTapped({ trail_id: trail?.trail_id });
            toggle();
            return;
          }

          setShowShareModal(true);
        }}
        icon={<Share color={COLOR_INTERACTIVE_DEFAULT} />}
        title={intl.formatMessage({ defaultMessage: 'Share' })}
        className={className}
        testId="share-action"
      />
      {renderShareModal(showShareModal, hideShareModal, shareObject, user, languageRegionCode, languageCode)}
    </>
  );
}

export default SharePopupButton;
